<template>
  <Popper
    trigger="click"
    :options="{}"
    :class="wrapperClass"
  >
    <div :class="popperClass">
      <slot />
    </div>
    <a
      slot="reference"
      href="#"
      :class="buttonClass"
      @click.prevent
      v-html="button"
    />
  </Popper>
</template>

<script type="text/babel">
import Popper from 'vue-popperjs'

export default {
  name: 'NepPopper',
  components: {
    Popper,
  },
  props: {
    button: {
      type: String,
      required: false,
      default: 'Button',
    },
    popperClass: {
      type: String,
      required: false,
      default: 'popper popper--menu',
    },
    buttonClass: {
      type: String,
      required: false,
      default: 'btn',
    },
    wrapperClass: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
